import { atom } from "recoil";

export const postModalState = atom({
  key: 'postModalState',
  default: false
})